import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { Ticker } from "./Ticker";
import { CommandPalette } from "./CommandPalette";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { RequireSubscription } from "@/lib/payments/RequireSubscription";
import { Toaster } from "@/components/ui/sonner";
import { PaymentTestModeBanner } from "@/components/PaymentTestModeBanner";
import { NexusReformBanner } from "@/components/nexus/NexusReformNotice";

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
    <div className="flex min-h-[100dvh] w-full max-w-full overflow-x-hidden bg-background text-foreground">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <PaymentTestModeBanner />
        <NexusReformBanner />
        <Topbar />
        <Ticker />
        <main className="min-h-0 flex-1 overflow-auto">
          <RequireSubscription>{children}</RequireSubscription>
        </main>
      </div>
      <CommandPalette />
      <Toaster />
    </div>
    </RequireAuth>
  );
}
